module.exports = "<div ng-if=\"item()\">{{ item().getValue() }}</div>"